import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Button, Card, Popconfirm, Table} from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash, BiCalendar } from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import ProveidorModal from "../menudesign/components/ProveidorModal";
import ProveidorsList from "../menudesign/components/ProveidorsList";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import {GetComandesGeneradesIdPdf} from "../../dao/menudesign/comandes/GetComandesGeneradesIdPdf";
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {GetProveidors} from "../../dao/menudesign/GetProveidors"
import {DeleteProveidors} from "../../dao/menudesign/DeleteProveidors"
import DistribucionsModal from "../menudesign/components/DistribucionsModal";
import Proveidor from '../../model/menudesign/Proveidor';



const Proveidors = () => {
    const titol: string = "Proveïdors";
    const nomPermis: string = "Proveidors";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Proveidor[]>([]);
    const [elementSelected, setElementSelected] = useState<Proveidor>(new Proveidor());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [nouDistribucio, setNouDistribucio] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);


    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());


    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetProveidors(page);
        await setDades(dades);
        await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: Proveidor) {
        await DeleteProveidors(id, page, userId);
        await checkDades();
    }

    
    function togleNouElement(element: any, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }
    function togleNouDistribucio(element: any) {
        setNouDistribucio(!nouDistribucio);
        setElementSelected(element);
    }

    async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        setNouDistribucio(false);
        await checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(proveidors: Proveidor[]) {
        if (proveidors && proveidors.length > 0) {
        const anyNames = proveidors.map((proveidors) => ({
            text: proveidors.nom,
            value: proveidors.nom,
        }));
        setNomFiltres(anyNames);
        }
    }
    const handleCloseDistribucio = async () => {
        setNouDistribucio(false);
        await checkDades();
    };

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    {/* {permisosEdicio && (  */}
                    <>
                        <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={() => togleNouElement(ele, true)}><BiPencil/></Button>
                        {" "}
                        <Button title={"Afegir Distribucions"} style={{backgroundColor: Colors.colors.color1, color:'white'}}
                                onClick={() => togleNouDistribucio(ele)}><BiCalendar /></Button>
                         {" "}
                        <Popconfirm
                            title="Eliminant"
                            description="Vols eliminar definitivament aquest element?"
                            onConfirm={() => deleteElement(ele)}
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        >
                            <Button title={"Eliminar"} style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                        </Popconfirm>
                        {" "}
                        
                    </>
                    {/* )} */}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<any> = {
        loading
    };


    function modificarDatosForm() {
        //form.setFieldsValue({ remesa: 0 });
    }

    const onChange: TableProps<any>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: any) => {
        return (
            <ProveidorsList element={ele}/>
        );
    };

    async function handleDownload (id: string)  {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            {/* {permisosEdicio && */}
                            <Button title={"Crear"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                togleNouElement(new Proveidor(),true)}><BiPlus/></Button>
                            {/* } */}
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                rowKey="id"
                                columns={columns}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                                dataSource={coleccio}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {nouElement && (
                        <ProveidorModal element={elementSelected} onClose={handleCloseModal} visible={nouElement} editar={editar}/>
                    )}
                    {nouDistribucio && (
                        <DistribucionsModal element={elementSelected} onClose={handleCloseDistribucio} visible={nouDistribucio}  />
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Proveidors;
